import { FC } from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import NarrowDeviceSearchBox from '@rover/react-lib/src/pages/index/HomePage/components/IntuitiveOwnerWizard/NarrowDeviceSearchBox';
import {
  actions as searchBoxActions,
  effects as searchBoxEffects,
  selectors as searchBoxSelectors,
} from '@rover/react-lib/src/pages/index/HomePage/components/SearchBox/SearchBox.duck';
import { selectors as countryConfigSelectors } from '@rover/react-lib/src/redux/ducks/countryConfiguration.duck';
import { selectors as currentUserSelectors } from '@rover/react-lib/src/redux/ducks/currentUser.duck';
import { selectors as petsSelectors } from '@rover/react-lib/src/redux/ducks/pets.duck';
import { ServiceLinks } from '@rover/shared/js/hooks/useServiceLinksShim';

export interface NarrowDeviceSearchBoxContainerProps {
  isAuthenticated: boolean;
  serviceLinksForCurrentRoute: ServiceLinks | null;
}

const actions = {
  updateFilters: searchBoxActions.updateFilters,
};

const selector = (state) => ({
  pets: petsSelectors.getPets(state),
  filters: searchBoxSelectors.getFilters(state),
  serviceType: searchBoxSelectors.getServiceType(state),
  serviceTypeOptions: searchBoxSelectors.getPetTypeServiceTypeOptions(state),
  countryHasDogTraining: countryConfigSelectors.getNavigationHasDogTraining(state),
  currentUserPostalCode: currentUserSelectors.getPostalCode(state),
});

const effects = {
  submit: searchBoxEffects.submit,
  submitTraining: searchBoxEffects.submitTraining,
};

const NarrowDeviceSearchBoxContainer: FC<NarrowDeviceSearchBoxContainerProps> = (props) => {
  return (
    <Connect actions={actions} selector={selector} effects={effects}>
      {(connectedProps) => <NarrowDeviceSearchBox {...connectedProps} {...props} />}
    </Connect>
  );
};

export default NarrowDeviceSearchBoxContainer;
